"use strict";
exports.__esModule = true;
var SimpleForm_1 = require("./SimpleForm");
exports.SimpleForm = SimpleForm_1.SimpleForm;
